import { FormProvider, useForm } from 'react-hook-form';
import DialogModal from '../../../../../atoms/dialog'
import InviteExpertFields from '../invite-expert/fields';
import { ThemeProvider } from '@emotion/react';
import { Box, CircularProgress, createTheme } from '@mui/material';
import { defaultFormTheme } from '../../../../../atoms/defaultFormTheme';
import { useProjectAgendaItems } from '../invite-expert/useProjectAgendaItems';
import { useSnackbar } from 'notistack';
import { shareAgendaHandler } from '../../../project-agenda/helper';
import FormCancelSubmitBtns from '../../../../../atoms/formCancelSubmitBtns';

type Props = {
  isOpen: boolean;
  handleClose: () => void;
  pe_id: string | null;
  project_id: string | null;
  isReshare: boolean;
  setLoading(b: boolean): void;
  refetch: () => Promise<void>,
}

const ShareAgenda = ({ isOpen, handleClose, pe_id, project_id, isReshare, setLoading, refetch }: Props) => {
  const { enqueueSnackbar } = useSnackbar();
  const methods = useForm({
    defaultValues: {
      send_invite: {
        email: true,
        whatsapp: false
      },
      share_agenda: true,
      agenda_id: [],
    },
  });

  const defaultTheme = createTheme(defaultFormTheme);
  const { agendas, loading: agendaLoading, error: agendaError } = useProjectAgendaItems(Number(project_id), Number(pe_id));

  const onSubmit = (data: any) => {
    try {
      setLoading(true);
      const selectedMethods =
        data?.send_invite && typeof data.send_invite === 'object' && !Array.isArray(data.send_invite)
          ? Object.entries(data.send_invite)
            .filter(([_, value]) => !!value) // only true values
            .map(([key]) => key.toUpperCase())
          : [];
      if (selectedMethods.length === 0) {
        enqueueSnackbar("Please select at least one invite method", {
          variant: "warning",
          autoHideDuration: 2000,
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
        });
        return;
      }
      if (!data?.selected_agendas || data?.selected_agendas?.length === 0) {
        enqueueSnackbar("Please select at least one agenda", {
          variant: "warning",
          autoHideDuration: 2000,
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
        });
        return;
      }
      shareAgendaHandler(Number(pe_id), enqueueSnackbar, handleClose, refetch, data?.selected_agendas, selectedMethods, setLoading);
    } catch (error) {
      setLoading(false);
    }
    finally {
      setLoading(false);
    }
  }

  if (agendaLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <DialogModal
      title={isReshare ? "Reshare Agenda" : "Share Agenda"}
      isOpen={isOpen}
      handleClose={handleClose}
    >
      <FormProvider {...methods}>
        <ThemeProvider theme={defaultTheme}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
              {project_id && (
                <>
                  <InviteExpertFields removeShareAgendOption agendaError={agendaError} agendas={agendas} />
                </>
              )}
              <FormCancelSubmitBtns
                handleClose={handleClose}
              />
            </form>
          </Box>
        </ThemeProvider>
      </FormProvider>
    </DialogModal>
  )
}

export default ShareAgenda